import { render, staticRenderFns } from "./ProductSignaturesCard.vue?vue&type=template&id=71f390da&scoped=true"
import script from "./ProductSignaturesCard.vue?vue&type=script&lang=js"
export * from "./ProductSignaturesCard.vue?vue&type=script&lang=js"
import style0 from "./ProductSignaturesCard.vue?vue&type=style&index=0&id=71f390da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f390da",
  null
  
)

export default component.exports